// Session-cookie helper (Phase 4.5 deliverable #7).
//
// The `app` process's session-cookie middleware (D3 deliverable)
// reads `tradingplatform_session` from the cookie jar. The UI's
// login flow sets this cookie; subsequent fetch() calls include
// it automatically.
//
// Phase 4.5 D7 placeholder: until the production /login
// endpoint lands (D7 follow-up), the operator can set the
// cookie via the login screen which writes a fixed token
// matching the in-memory allow-list configured at app start.
// Phase 4.5 D7 follow-up replaces this with a POST /api/v1/login
// that authenticates against a sessions table (TDD §13.2).

const COOKIE_NAME = "tradingplatform_session";

/** Returns the current session token if set, or null. */
export function getSessionToken(): string | null {
  const match = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  return match.slice(COOKIE_NAME.length + 1);
}

/** Set the session cookie. Same-origin loopback (TDD §13.2)
 * means SameSite=Strict + HttpOnly are right defaults — but
 * HttpOnly can only be set by the SERVER (HTTP response
 * Set-Cookie header). Until the production /login endpoint
 * lands, the UI sets the cookie client-side without HttpOnly;
 * D7 follow-up replaces this.
 */
export function setSessionToken(token: string): void {
  // Path=/ so all routes share; SameSite=Strict for CSRF defense
  // even on loopback. No Secure attribute because we may be on
  // http://127.0.0.1 during development.
  document.cookie = `${COOKIE_NAME}=${token}; Path=/; SameSite=Strict`;
}

/** Clear the session cookie (logout). */
export function clearSessionToken(): void {
  document.cookie = `${COOKIE_NAME}=; Path=/; SameSite=Strict; Max-Age=0`;
}

/** True iff a session cookie is present. Does NOT verify the
 * cookie is valid — the server-side middleware does that.
 */
export function hasSession(): boolean {
  return getSessionToken() !== null;
}
